export default __webpack_public_path__ + "static/media/large-lowest.7b91b73e.svg";